import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "survey-wrapper" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { style: {"display":"flex","gap":"4px","width":"100%"} }
const _hoisted_5 = { class: "agreement-container" }
const _hoisted_6 = { class: "agreement-radios" }
const _hoisted_7 = { class: "info-text" }

import UserNavbar from "@/components/UserNavbar.vue";
import UserFooter from "@/components/UserFooter.vue";
import Loading from "@/components/Loading.vue";
import { ref, h, onMounted, computed } from "vue";
import * as common from "@/assets/common/common";
import { useRoute } from "vue-router";
import {
  useNotification,
  NForm,
  NFormItem,
  NInput,
  NButton,
  NRadioGroup,
  NRadio,
  NSpace,
  NAutoComplete,
  NCard,
  FormInst,
  FormRules,
} from "naive-ui";
import { getCallable, makeCallApiParam } from "@/config/env";
import { useActionDialog } from "@/composables/useDialog"; // useActionDialog import 추가
const getSurveyInfo = "getSurveyInfo";
const checkSurveyInfo = "checkSurveyInfo";
interface SurveyInfo {
  authCode: string;
  dobYear: string;
  dobMonth: string;
  dobDay: string;
  email: string;
  gender: string;
  name: string;
  major: string;
  grade: string; // Can be string or number, handle as string
  class: string; // Can be string or number, handle as string
  num: string;
  form_id: string;
  org_name: string;
  responder_uri: string;
  type: string;
  entry_ids: string[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Survey',
  setup(__props) {

const { show: showActionDialog } = useActionDialog();

const callApiCallable = getCallable("callApi");

const isAgreed = ref<string | null>(null);
const route = useRoute();
const projectSKFromRoute = ref<string | null>(null);
const projectName = ref<string | null>(null);
const isSubmitting = ref(false);
const loading = ref(false);
const formRef = ref<FormInst | null>(null);
const isOrg = ref(false);
const notification = useNotification();
const formModel = ref<SurveyInfo>({
  authCode: "",
  dobYear: "",
  dobMonth: "",
  dobDay: "",
  email: "",
  gender: "",
  name: "",
  major: "",
  grade: "",
  class: "",
  num: "",
  form_id: "",
  org_name: "",
  responder_uri: "",
  type: "",
  entry_ids: [],
});

const rules: FormRules = {
  authCode: [
    {
      required: true,
      message: "인증코드를 입력해주세요.",
      trigger: ["input", "blur"],
    },
  ],
  num: [
    {
      required: true,
      message: "학번 또는 번호를 입력해주세요.",
      trigger: ["input", "blur"],
    },
  ],
  name: [
    {
      required: true,
      message: "성명을 입력해주세요.",
      trigger: ["input", "blur"],
    },
  ],
  gender: [
    { required: true, message: "성별을 선택해주세요.", trigger: "change" },
  ],
  dobYear: [
    { required: true, message: "연도 입력", trigger: ["input", "blur", "change"] },
    { pattern: /^[0-9]{4}$/, message: "4자리 숫자", trigger: ["input", "blur"] }
  ],
  dobMonth: [
    { required: true, message: "월 입력", trigger: ["input", "blur", "change"] },
    { pattern: /^(0?[1-9]|1[012])$/, message: "1~12", trigger: ["input", "blur"] }
  ],
  dobDay: [
    { required: true, message: "일 입력", trigger: ["input", "blur", "change"] },
    { pattern: /^(0?[1-9]|[12][0-9]|3[01])$/, message: "1~31", trigger: ["input", "blur"] }
  ],
  email: [
    {
      required: true,
      message: "이메일을 입력해주세요.",
      trigger: ["input", "blur"],
    },
    {
      type: "email",
      message: "올바른 이메일 형식이 아닙니다.",
      trigger: ["blur", "input"],
    },
  ],
};

const currentYear = new Date().getFullYear();
const yearOptions = Array.from({ length: 100 }, (_, i) => ({
  label: String(currentYear - i),
  value: String(currentYear - i),
}));
const monthOptions = Array.from({ length: 12 }, (_, i) => ({
  label: String(i + 1).padStart(2, "0"),
  value: String(i + 1).padStart(2, "0"),
}));
const dayOptions = Array.from({ length: 31 }, (_, i) => ({
  label: String(i + 1).padStart(2, "0"),
  value: String(i + 1).padStart(2, "0"),
}));

function moveSurvey() {
  const {
    authCode,
    org_name,
    type,
    major,
    grade,
    class: className,
    num,
    name,
    gender,
    dobYear,
    dobMonth,
    dobDay,
    email,
    entry_ids,
    responder_uri,
  } = formModel.value;

  const valuesToSubmit: string[] = [];

  valuesToSubmit.push(authCode.toUpperCase());
  valuesToSubmit.push(org_name);
  if (type === "putt_u" || type === "tec") {
    valuesToSubmit.push(num);
    valuesToSubmit.push(major);
  } else {
    const classNameStr = isNaN(Number(className)) ? className.toString() : className.toString().padStart(2, "0");
    const numStr = isNaN(Number(num)) ? num.toString() : num.toString().padStart(2, "0");
    valuesToSubmit.push(`${grade}_${classNameStr}_${numStr}`);
  }
  const formattedDob = `${dobYear}${dobMonth.padStart(2, "0")}${dobDay.padStart(2, "0")}`;
  valuesToSubmit.push(name, gender, formattedDob, email);

  if (entry_ids.length > 0 && entry_ids.length === valuesToSubmit.length) {
    const params = new URLSearchParams();
    entry_ids.forEach((id, index) => {
      params.append(id, valuesToSubmit[index]);
    });
    const surveyUrl = `${responder_uri}?usp=pp_url&${params.toString()}`;
    window.location.href = surveyUrl;
  } else {
    // notification.error({
    //     title: "오류",
    //     description: "진단 양식 정보를 구성하는 데 실패했습니다.",
    //     duration: 5000,
    // });
    window.location.href = responder_uri;
  }
  isSubmitting.value = false;
}

async function startSurvey() {
  try {
    await formRef.value?.validate();
  } catch (errors) {
    notification.error({
      title: "입력 오류",
      description: "필수 정보를 모두 입력해주세요.",
      duration: 3000,
    });
    return;
  }
  isSubmitting.value = true;

  const result = await callApiCallable(
    makeCallApiParam(checkSurveyInfo, {
      SK: projectSKFromRoute.value,
      authCode: formModel.value.authCode.toUpperCase(),
    })
  );
  if (common.evalFunctionResult(result)) {
    moveSurvey();
  } else {
    const code = common.getResultCode(result);
    if (code == "110") {
      showActionDialog({
        title: "경고",
        content: () =>
          h("div", null, [
            h(
              "p",
              { style: { color: "red", fontWeight: "bold" } },
              "이미 사용한 인증코드입니다."
            ),
            h("p", "무시하고 다시 검사를 진행 하시겠습니까?"),
          ]),
        positiveText: "확인",
        negativeText: "취소",
        positiveButtonProps: { type: "error" },
        confirmButtonLoadingText: "처리 중...",
        onConfirm: async () => {
          try {
            moveSurvey();
          } catch (error: any) {
            throw error;
          }
        },
      });
    } else {
      const err = common.getResultError(result);
      notification.error({
        title: "오류",
        description: err,
        duration: 5000,
      });
    }
    isSubmitting.value = false;
  }
}

onMounted(async () => {
  loading.value = true;
  projectSKFromRoute.value = route.params.SK as string;
  isOrg.value = projectSKFromRoute.value.startsWith("project#org#");
  projectSKFromRoute.value = decodeURIComponent(projectSKFromRoute.value);
  const result = await callApiCallable(
    makeCallApiParam(getSurveyInfo, { SK: projectSKFromRoute.value })
  );
  if (common.evalFunctionResult(result)) {
    const surveyInfo: SurveyInfo = common.getItemFromFunctionResult(result);
    formModel.value = { ...surveyInfo, dobYear: "", dobMonth: "", dobDay: "" };
    formModel.value.num = "";
    projectName.value = common.getProjectName(formModel.value.type);
    if (isOrg.value == false) {
      formModel.value.org_name = "";
    }

    loading.value = false;
  } else {
    loading.value = false;
    notification.error({
      title: "조회 실패",
      description:
        common.getResultError(result) ||
        "진단 정보를 불러오는 중 오류가 발생했습니다.",
      duration: 3000,
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(Loading, null, null, 512), [
      [_vShow, loading.value]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(projectName.value), 1),
      _createVNode(_unref(NCard), {
        bordered: false,
        class: "form-card",
        "content-style": "padding: 16px;"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NForm), {
            ref_key: "formRef",
            ref: formRef,
            model: formModel.value,
            rules: rules,
            "label-placement": "left",
            "label-width": "auto",
            "require-mark-placement": "right-hanging"
          }, {
            default: _withCtx(() => [
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "section-header" }, "기본 인적 정보", -1)),
              _createVNode(_unref(NFormItem), { label: "검사기관" }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createElementVNode("span", { class: "readonly-text" }, "주식회사 코코랩", -1)
                ])),
                _: 1
              }),
              _createVNode(_unref(NFormItem), {
                label: "인증코드",
                path: "authCode"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInput), {
                    value: formModel.value.authCode,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formModel.value.authCode) = $event)),
                    placeholder: "인증코드를 입력하세요"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_unref(NFormItem), { label: "기관명" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInput), {
                    value: formModel.value.org_name,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formModel.value.org_name) = $event)),
                    disabled: isOrg.value
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              }),
              (formModel.value.type == 'putt_u' || formModel.value.type == 'tec')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_unref(NFormItem), { label: "학과 또는 전공" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NInput), {
                          value: formModel.value.major,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formModel.value.major) = $event)),
                          disabled: isOrg.value
                        }, null, 8, ["value", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(NFormItem), {
                      label: "학번",
                      path: "num"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NInput), {
                          value: formModel.value.num,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formModel.value.num) = $event)),
                          placeholder: "학번을 입력하세요"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_unref(NFormItem), { label: "학년" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NInput), {
                          value: formModel.value.grade,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((formModel.value.grade) = $event)),
                          disabled: isOrg.value
                        }, null, 8, ["value", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(NFormItem), { label: "반" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NInput), {
                          value: formModel.value.class,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((formModel.value.class) = $event)),
                          disabled: isOrg.value
                        }, null, 8, ["value", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(NFormItem), {
                      label: "번호",
                      path: "num"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NInput), {
                          value: formModel.value.num,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((formModel.value.num) = $event)),
                          placeholder: "번호를 입력하세요"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ], 64)),
              _createVNode(_unref(NFormItem), {
                label: "성명",
                path: "name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInput), {
                    value: formModel.value.name,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((formModel.value.name) = $event)),
                    placeholder: "성명을 입력하세요"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_unref(NFormItem), {
                label: "성별",
                path: "gender"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NRadioGroup), {
                    value: formModel.value.gender,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((formModel.value.gender) = $event)),
                    name: "gender-group"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NSpace), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NRadio), { value: "남" }, {
                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                              _createTextVNode("남")
                            ])),
                            _: 1
                          }),
                          _createVNode(_unref(NRadio), { value: "여" }, {
                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                              _createTextVNode("여")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_unref(NFormItem), {
                label: "생년월일",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_unref(NFormItem), {
                      path: "dobYear",
                      style: {"flex":"1.3","margin-bottom":"0"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NAutoComplete), {
                          value: formModel.value.dobYear,
                          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((formModel.value.dobYear) = $event)),
                          options: _unref(yearOptions),
                          "get-show": () => true,
                          placeholder: "연도",
                          clearable: ""
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(NFormItem), {
                      path: "dobMonth",
                      style: {"flex":"1","margin-bottom":"0"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NAutoComplete), {
                          value: formModel.value.dobMonth,
                          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((formModel.value.dobMonth) = $event)),
                          options: _unref(monthOptions),
                          "get-show": () => true,
                          placeholder: "월",
                          clearable: ""
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(NFormItem), {
                      path: "dobDay",
                      style: {"flex":"1","margin-bottom":"0"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NAutoComplete), {
                          value: formModel.value.dobDay,
                          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((formModel.value.dobDay) = $event)),
                          options: _unref(dayOptions),
                          "get-show": () => true,
                          placeholder: "일",
                          clearable: ""
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(NFormItem), {
                label: "이메일",
                path: "email"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInput), {
                    value: formModel.value.email,
                    "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((formModel.value.email) = $event)),
                    placeholder: "이메일을 입력하세요"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]),
          _createElementVNode("div", _hoisted_5, [
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "section-header" }, "개인정보이용동의서", -1)),
            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "agreement-content" }, [
              _createTextVNode(" 개인정보보호법에 관한 법률 제3조(개인정보 보호 원칙), 제15조(개인정보의 수집‧이용), 제17조(개인정보의 제공)에 따라, "),
              _createElementVNode("br"),
              _createElementVNode("br"),
              _createTextVNode(" PUTT2.0 및 TOCC 응답 결과의 개인 확인, 결과 분석, 결과리포트 발송에 필요한 귀하의 개인정보 수집을 위한 동의를 구하고자 합니다. "),
              _createElementVNode("br"),
              _createElementVNode("br"),
              _createTextVNode(" 귀하께서 개인정보(기관명(학교명), 학번(또는 반번), 성명, 성별, 생년월일, email 주소) 수집, 이용에 동의하십니까? "),
              _createElementVNode("br"),
              _createElementVNode("br"),
              _createTextVNode(" 단, 귀하께서 개인정보이용에 ‘동의하지 않음’에 표기한 경우, 응답 결과의 분석 및 결과리포트 발송이 불가능함을 알려드립니다. ")
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(NRadioGroup), {
                value: isAgreed.value,
                "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((isAgreed).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NSpace), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NRadio), { value: "agree" }, {
                        default: _withCtx(() => _cache[18] || (_cache[18] = [
                          _createTextVNode("동의함")
                        ])),
                        _: 1
                      }),
                      _createVNode(_unref(NRadio), { value: "disagree" }, {
                        default: _withCtx(() => _cache[19] || (_cache[19] = [
                          _createTextVNode("동의하지 않음")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ])
          ]),
          _createVNode(_unref(NButton), {
            loading: isSubmitting.value,
            type: "primary",
            onClick: startSurvey,
            disabled: isAgreed.value !== 'agree',
            block: "",
            size: "large",
            style: {"margin-top":"20px"}
          }, {
            default: _withCtx(() => _cache[22] || (_cache[22] = [
              _createTextVNode(" 진단시작 ")
            ])),
            _: 1
          }, 8, ["loading", "disabled"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", null, _toDisplayString(projectName.value), 1),
        _cache[23] || (_cache[23] = _createElementVNode("span", null, "진단은 외부 서비스(Google Form)를 통해 진행됩니다.", -1)),
        _cache[24] || (_cache[24] = _createElementVNode("span", null, " ", -1)),
        _cache[25] || (_cache[25] = _createElementVNode("span", null, [
          _createElementVNode("b", null, "COKOLab. Inc.")
        ], -1))
      ])
    ])
  ]))
}
}

})